import { store } from '@/store';
import QuestionBuilder from './QuestionBuilder';

export default class TrimQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(true, false);
    }

    answers() {
        const trims = store.getters['vehicleSearchModule/trims'];
        return trims;
    }

    setAnswer(answer: string) {
        store.dispatch('vehicleModule/submitTrims', null);
        store.dispatch('vehicleModule/submitTrims', [answer]);
        store.dispatch('vehicleSearchModule/updateFilteredResults');
    }
}
